const routeRecordMatches = (routeRecord, matchedRouteNames) => {
  if (routeRecord.name && matchedRouteNames.has(routeRecord.name)) {
    return true
  }

  return (
    routeRecord.children?.some((childRoute) =>
      routeRecordMatches(childRoute, matchedRouteNames),
    ) ?? false
  )
}

const moduleRouteMatches = (moduleRoutes, routeTo) => {
  const matchedRouteNames = new Set(
    routeTo.matched
      .map((matchedRoute) => matchedRoute.name)
      .filter((routeName) => routeName != null),
  )

  return moduleRoutes.some((routeRecord) =>
    routeRecordMatches(routeRecord, matchedRouteNames),
  )
}

export default moduleRouteMatches
